<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <Guifu v-show="guifuIsVisible"/>
    <Poison v-show="poisonIsVisible"/>
    <Yisheng v-show="yishengIsVisible"/>
    <!--  页脚 -->
    <Footer/>
  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import Guifu from "@/views/business/website/guifu.vue";
import Poison from "@/views/business/website/poison.vue";
import Yisheng from "@/views/business/website/yisheng.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Guifu,
    Poison,
    Yisheng,
    Footer
  },
  data(){
    return{
      //跳转页面类型
      type:"",
      guifuIsVisible: false,
      poisonIsVisible: false,
      yishengIsVisible: false,
    }
  },
  watch:{
    '$route.query.type': {
      immediate: true, // 初始化时也执行
      handler(newVal) {
        if (newVal) {
          this.onchangeType(newVal);
        } else {
          this.$message.warning("参数不能为空");
        }
      },
    }
  },
  methods:{
    onchangeType(newVal) {
      if (newVal === 'gf') {
        this.guifuIsVisible = true;
        this.poisonIsVisible = false;
        this.yishengIsVisible = false;
      } else if(newVal === 'poison'){
        this.poisonIsVisible = true;
        this.guifuIsVisible = false;
        this.yishengIsVisible = false;
      }else if(newVal === 'ys'){
        this.yishengIsVisible = true;
        this.guifuIsVisible = false;
        this.poisonIsVisible = false;
      }else{
        this.guifuIsVisible = false;
        this.poisonIsVisible = false;
        this.yishengIsVisible = false;
      }
    }
  }
}
</script>

<style>
</style>